{
  "name": "@vercel/client",
  "version": "13.0.4",
  "main": "dist/index.js",
  "typings": "dist/index.d.ts",
  "homepage": "https://vercel.com",
  "license": "Apache-2.0",
  "files": [
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/vercel/vercel.git",
    "directory": "packages/client"
  },
  "scripts": {
    "build": "node ../../utils/build.mjs",
    "test-e2e": "pnpm test tests/create-deployment.test.ts tests/create-legacy-deployment.test.ts tests/paths.test.ts",
    "test": "jest --reporters=default --reporters=jest-junit --env node --verbose --runInBand --bail",
    "test-unit": "pnpm test tests/unit.*test.*"
  },
  "engines": {
    "node": ">= 16"
  },
  "devDependencies": {
    "@types/async-retry": "1.4.5",
    "@types/fs-extra": "7.0.0",
    "@types/jest": "27.4.1",
    "@types/minimatch": "3.0.5",
    "@types/ms": "0.7.30",
    "@types/node": "14.18.33",
    "@types/node-fetch": "2.5.4",
    "@types/recursive-readdir": "2.2.0",
    "@types/tar-fs": "1.16.1",
    "jest-junit": "16.0.0",
    "typescript": "4.9.5"
  },
  "dependencies": {
    "@vercel/build-utils": "7.2.1",
    "@vercel/routing-utils": "3.0.0",
    "@zeit/fetch": "5.2.0",
    "async-retry": "1.2.3",
    "async-sema": "3.0.0",
    "fs-extra": "8.0.1",
    "ignore": "4.0.6",
    "minimatch": "5.0.1",
    "ms": "2.1.2",
    "node-fetch": "2.6.7",
    "querystring": "^0.2.0",
    "sleep-promise": "8.0.1",
    "tar-fs": "1.16.3"
  }
}
